<div #scrollTop class="scroll-top cursor-pointer" (click)="onScrollToTop()">
  <img
    src="https://media.umangapp.in/cdn/landing/theme/icons/scroll-top.svg"
    alt="scroll-top"
    width="60px"
    height="60px"
    loading="lazy"
    fetchpriority="high"
    
  />
</div>
